export default {
  LOADING_START: '@k-share/ui/LOADING_SET',
  LOADING_END: '@k-share/ui/LOADING_END',
  APP_NOTIFICATION_SET: '@k-share/ui/APP_NOTIFICATION_SET',
  APP_NOTIFICATION_DELETE: '@k-share/ui/APP_NOTIFICATION_DELETE',
  LANGUAGE_SET: '@k-share/ui/LANGUAGE_SET',
};
